/* 4093e1a64c461b5c155fe0458ff282ae7c40590c
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerAddressesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerAddressesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', phone_number: string, addresses?: Array<{ __typename?: 'CustomerAddress', city?: string | null, company?: string | null, country_code?: Types.CountryCodeEnum | null, country_id?: string | null, customer_id?: number | null, default_billing?: boolean | null, default_shipping?: boolean | null, fax?: string | null, firstname?: string | null, id?: number | null, lastname?: string | null, middlename?: string | null, postcode?: string | null, prefix?: string | null, region_id?: number | null, street?: Array<string | null> | null, suffix?: string | null, telephone?: string | null, vat_id?: string | null, district?: string | null, district_id?: number | null, ward?: string | null, ward_id?: number | null, region?: { __typename?: 'CustomerAddressRegion', region?: string | null, region_code?: string | null, region_id?: number | null } | null, extension_attributes?: Array<{ __typename?: 'CustomerAddressAttribute', attribute_code?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type OrdersQueryVariables = Types.Exact<{
  scope?: Types.InputMaybe<Types.ScopeTypeEnum>;
  currentPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sort?: Types.InputMaybe<Types.CustomerOrderSortInput>;
}>;


export type OrdersQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', orders?: { __typename?: 'CustomerOrders', total_count?: number | null, items: Array<{ __typename?: 'CustomerOrder', id: string, order_date: string, number: string, status: string, total?: { __typename?: 'OrderTotal', grand_total: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, items?: Array<{ __typename?: 'OrderItem', id: string, product_name?: string | null, product_image?: string | null, product_sku: string, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, selected_options?: Array<{ __typename?: 'OrderItemOption', label: string, value: string } | null> | null } | null> | null } | null> } | null } | null };

export type OrderItemBasicFragment = { __typename?: 'OrderItem', id: string, product_name?: string | null, product_image?: string | null, product_sku: string, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, selected_options?: Array<{ __typename?: 'OrderItemOption', label: string, value: string } | null> | null };

export type OrderDetailQueryVariables = Types.Exact<{
  scope?: Types.InputMaybe<Types.ScopeTypeEnum>;
  filter?: Types.InputMaybe<Types.CustomerOrdersFilterInput>;
}>;


export type OrderDetailQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', orders?: { __typename?: 'CustomerOrders', total_count?: number | null, items: Array<{ __typename?: 'CustomerOrder', id: string, order_date: string, number: string, status: string, shipping_method?: string | null, total?: { __typename?: 'OrderTotal', grand_total: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, subtotal: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, total_shipping: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, discounts?: Array<{ __typename?: 'Discount', label: string, amount: { __typename?: 'Money', value?: number | null, currency?: Types.CurrencyEnum | null } } | null> | null, base_grand_total: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null } } | null, items?: Array<{ __typename?: 'OrderItem', id: string, product_name?: string | null, product_image?: string | null, product_sku: string, quantity_ordered?: number | null, product_sale_price: { __typename?: 'Money', currency?: Types.CurrencyEnum | null, value?: number | null }, selected_options?: Array<{ __typename?: 'OrderItemOption', label: string, value: string } | null> | null } | null> | null, payment_methods?: Array<{ __typename?: 'OrderPaymentMethod', name: string, type: string, additional_data?: Array<{ __typename?: 'KeyValue', name?: string | null, value?: string | null } | null> | null } | null> | null, shipping_address?: { __typename?: 'OrderAddress', city: string, company?: string | null, firstname: string, lastname: string, region?: string | null, street: Array<string | null>, telephone?: string | null, district?: string | null, ward?: string | null } | null } | null> } | null } | null };

export type CustomerFaqQueryVariables = Types.Exact<{
  currentPage: Types.Scalars['Int']['input'];
  pageSize: Types.Scalars['Int']['input'];
}>;


export type CustomerFaqQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', faq?: { __typename?: 'CustomerFaq', data?: Array<{ __typename?: 'CustomerFaqData', id?: number | null, name?: string | null, content?: string | null, status?: number | null, create_at?: string | null, visibility?: number | null, item?: { __typename?: 'FaqItem', type?: string | null, id?: number | null, url_key?: string | null, name?: string | null } | null } | null> | null, pagination_metadata?: { __typename?: 'PaginationData', total_items?: number | null, current_page?: number | null, total_pages?: number | null } | null } | null } | null };

export type CustomerReviewsQueryVariables = Types.Exact<{
  filter: Types.CustomerReviewFilterInput;
}>;


export type CustomerReviewsQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', reviews?: { __typename?: 'CustomerReviewsResponse', total_count?: number | null, items?: Array<{ __typename?: 'Review', id?: string | null, detail?: string | null, percent?: number | null, status_code?: string | null, createdAt?: any | null, product?: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null, name?: string | null, canonical_url?: string | null, small_image?: { __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null } | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, canonical_url?: string | null, small_image?: { __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null } | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null, name?: string | null, canonical_url?: string | null, small_image?: { __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null } | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null, name?: string | null, canonical_url?: string | null, small_image?: { __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null } | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, canonical_url?: string | null, small_image?: { __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null } | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null, name?: string | null, canonical_url?: string | null, small_image?: { __typename?: 'ProductImage', url?: string | null, position?: number | null, label?: string | null } | null } | null } | null> | null, page_info?: { __typename?: 'PageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null } | null };

export type ChangeCustomerPasswordMutationVariables = Types.Exact<{
  currentPassword: Types.Scalars['String']['input'];
  newPassword: Types.Scalars['String']['input'];
}>;


export type ChangeCustomerPasswordMutation = { __typename?: 'Mutation', changeCustomerPassword?: { __typename?: 'Customer', email?: string | null, firstname?: string | null, lastname?: string | null, phone_number: string } | null };

export type UpdateCustomerMutationVariables = Types.Exact<{
  input: Types.CustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'CustomerOutput', customer: { __typename?: 'Customer', firstname?: string | null, lastname?: string | null } } | null };

export type CustomerRankQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerRankQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', rank?: string | null } | null };

export type CreateCustomerAddressMutationVariables = Types.Exact<{
  input: Types.CustomerAddressInput;
}>;


export type CreateCustomerAddressMutation = { __typename?: 'Mutation', createCustomerAddress?: { __typename?: 'CustomerAddress', city?: string | null, company?: string | null, firstname?: string | null, id?: number | null, lastname?: string | null, district_id?: number | null, district?: string | null, ward?: string | null, ward_id?: number | null, telephone?: string | null, street?: Array<string | null> | null, region?: { __typename?: 'CustomerAddressRegion', region?: string | null, region_code?: string | null } | null } | null };

export type UpdateCustomerAddressMutationVariables = Types.Exact<{
  updateCustomerAddressId: Types.Scalars['Int']['input'];
  input?: Types.InputMaybe<Types.CustomerAddressInput>;
}>;


export type UpdateCustomerAddressMutation = { __typename?: 'Mutation', updateCustomerAddress?: { __typename?: 'CustomerAddress', city?: string | null, company?: string | null, firstname?: string | null, id?: number | null, lastname?: string | null, district_id?: number | null, district?: string | null, ward?: string | null, ward_id?: number | null, telephone?: string | null, street?: Array<string | null> | null, region?: { __typename?: 'CustomerAddressRegion', region?: string | null, region_code?: string | null } | null } | null };

export type DeleteCustomerAddressMutationVariables = Types.Exact<{
  deleteCustomerAddressId: Types.Scalars['Int']['input'];
}>;


export type DeleteCustomerAddressMutation = { __typename?: 'Mutation', deleteCustomerAddress?: boolean | null };

export type CustomerWishlistQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerWishlistQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', wishlist: { __typename?: 'Wishlist', items_count?: number | null, items?: Array<{ __typename?: 'WishlistItem', id?: number | null, product?: { __typename?: 'BundleProduct', sku?: string | null } | { __typename?: 'ConfigurableProduct', sku?: string | null } | { __typename?: 'DownloadableProduct', sku?: string | null } | { __typename?: 'GroupedProduct', sku?: string | null } | { __typename?: 'SimpleProduct', sku?: string | null } | { __typename?: 'VirtualProduct', sku?: string | null } | null } | null> | null } } | null };

export type CustomerListAddressesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerListAddressesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', phone_number: string, addresses?: Array<{ __typename?: 'CustomerAddress', default_billing?: boolean | null, default_shipping?: boolean | null, id?: number | null } | null> | null } | null };

export const OrderItemBasicFragmentDoc = gql`
    fragment OrderItemBasic on OrderItem {
  id
  product_name
  product_image
  product_sku
  quantity_ordered
  product_sale_price {
    currency
    value
  }
  selected_options {
    label
    value
  }
}
    `;
export const CustomerAddressesDocument = gql`
    query CustomerAddresses {
  customer {
    phone_number
    addresses {
      city
      company
      country_code
      country_id
      customer_id
      default_billing
      default_shipping
      fax
      firstname
      id
      lastname
      middlename
      postcode
      prefix
      region {
        region
        region_code
        region_id
      }
      region_id
      street
      suffix
      telephone
      vat_id
      extension_attributes {
        attribute_code
        value
      }
      district
      district_id
      ward
      ward_id
    }
  }
}
    `;

/**
 * __useCustomerAddressesQuery__
 *
 * To run a query within a React component, call `useCustomerAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerAddressesQuery(baseOptions?: Apollo.QueryHookOptions<CustomerAddressesQuery, CustomerAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, options);
      }
export function useCustomerAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerAddressesQuery, CustomerAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, options);
        }
export function useCustomerAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerAddressesQuery, CustomerAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerAddressesQuery, CustomerAddressesQueryVariables>(CustomerAddressesDocument, options);
        }
export type CustomerAddressesQueryHookResult = ReturnType<typeof useCustomerAddressesQuery>;
export type CustomerAddressesLazyQueryHookResult = ReturnType<typeof useCustomerAddressesLazyQuery>;
export type CustomerAddressesSuspenseQueryHookResult = ReturnType<typeof useCustomerAddressesSuspenseQuery>;
export type CustomerAddressesQueryResult = Apollo.QueryResult<CustomerAddressesQuery, CustomerAddressesQueryVariables>;
export const OrdersDocument = gql`
    query Orders($scope: ScopeTypeEnum, $currentPage: Int, $pageSize: Int, $sort: CustomerOrderSortInput) {
  customer {
    orders(
      scope: $scope
      currentPage: $currentPage
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        id
        order_date
        number
        status
        total {
          grand_total {
            currency
            value
          }
        }
        items {
          ... on OrderItem {
            ...OrderItemBasic
          }
        }
      }
      total_count
    }
  }
}
    ${OrderItemBasicFragmentDoc}`;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export function useOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersSuspenseQueryHookResult = ReturnType<typeof useOrdersSuspenseQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const OrderDetailDocument = gql`
    query OrderDetail($scope: ScopeTypeEnum, $filter: CustomerOrdersFilterInput) {
  customer {
    orders(scope: $scope, filter: $filter) {
      items {
        id
        order_date
        number
        status
        total {
          grand_total {
            currency
            value
          }
          subtotal {
            currency
            value
          }
          total_shipping {
            currency
            value
          }
          discounts {
            amount {
              value
              currency
            }
            label
          }
          base_grand_total {
            currency
            value
          }
        }
        items {
          ... on OrderItem {
            ...OrderItemBasic
          }
        }
        shipping_method
        payment_methods {
          additional_data {
            name
            value
          }
          name
          type
        }
        shipping_address {
          city
          company
          firstname
          lastname
          region
          street
          telephone
          district
          ward
        }
      }
      total_count
    }
  }
}
    ${OrderItemBasicFragmentDoc}`;

/**
 * __useOrderDetailQuery__
 *
 * To run a query within a React component, call `useOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderDetailQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOrderDetailQuery(baseOptions?: Apollo.QueryHookOptions<OrderDetailQuery, OrderDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderDetailQuery, OrderDetailQueryVariables>(OrderDetailDocument, options);
      }
export function useOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderDetailQuery, OrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderDetailQuery, OrderDetailQueryVariables>(OrderDetailDocument, options);
        }
export function useOrderDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrderDetailQuery, OrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrderDetailQuery, OrderDetailQueryVariables>(OrderDetailDocument, options);
        }
export type OrderDetailQueryHookResult = ReturnType<typeof useOrderDetailQuery>;
export type OrderDetailLazyQueryHookResult = ReturnType<typeof useOrderDetailLazyQuery>;
export type OrderDetailSuspenseQueryHookResult = ReturnType<typeof useOrderDetailSuspenseQuery>;
export type OrderDetailQueryResult = Apollo.QueryResult<OrderDetailQuery, OrderDetailQueryVariables>;
export const CustomerFaqDocument = gql`
    query CustomerFaq($currentPage: Int!, $pageSize: Int!) {
  customer {
    faq(currentPage: $currentPage, pageSize: $pageSize) {
      data {
        id
        name
        content
        item {
          type
          id
          url_key
          name
        }
        status
        create_at
        visibility
      }
      pagination_metadata {
        total_items
        current_page
        total_pages
      }
    }
  }
}
    `;

/**
 * __useCustomerFaqQuery__
 *
 * To run a query within a React component, call `useCustomerFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFaqQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useCustomerFaqQuery(baseOptions: Apollo.QueryHookOptions<CustomerFaqQuery, CustomerFaqQueryVariables> & ({ variables: CustomerFaqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFaqQuery, CustomerFaqQueryVariables>(CustomerFaqDocument, options);
      }
export function useCustomerFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFaqQuery, CustomerFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFaqQuery, CustomerFaqQueryVariables>(CustomerFaqDocument, options);
        }
export function useCustomerFaqSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerFaqQuery, CustomerFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerFaqQuery, CustomerFaqQueryVariables>(CustomerFaqDocument, options);
        }
export type CustomerFaqQueryHookResult = ReturnType<typeof useCustomerFaqQuery>;
export type CustomerFaqLazyQueryHookResult = ReturnType<typeof useCustomerFaqLazyQuery>;
export type CustomerFaqSuspenseQueryHookResult = ReturnType<typeof useCustomerFaqSuspenseQuery>;
export type CustomerFaqQueryResult = Apollo.QueryResult<CustomerFaqQuery, CustomerFaqQueryVariables>;
export const CustomerReviewsDocument = gql`
    query CustomerReviews($filter: CustomerReviewFilterInput!) {
  customer {
    reviews(filter: $filter) {
      items {
        id
        detail
        percent
        status_code
        createdAt
        product {
          id
          sku
          name
          canonical_url
          small_image {
            url
            position
            label
          }
        }
      }
      total_count
      page_info {
        current_page
        page_size
        total_pages
      }
    }
  }
}
    `;

/**
 * __useCustomerReviewsQuery__
 *
 * To run a query within a React component, call `useCustomerReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerReviewsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCustomerReviewsQuery(baseOptions: Apollo.QueryHookOptions<CustomerReviewsQuery, CustomerReviewsQueryVariables> & ({ variables: CustomerReviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, options);
      }
export function useCustomerReviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerReviewsQuery, CustomerReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, options);
        }
export function useCustomerReviewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerReviewsQuery, CustomerReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerReviewsQuery, CustomerReviewsQueryVariables>(CustomerReviewsDocument, options);
        }
export type CustomerReviewsQueryHookResult = ReturnType<typeof useCustomerReviewsQuery>;
export type CustomerReviewsLazyQueryHookResult = ReturnType<typeof useCustomerReviewsLazyQuery>;
export type CustomerReviewsSuspenseQueryHookResult = ReturnType<typeof useCustomerReviewsSuspenseQuery>;
export type CustomerReviewsQueryResult = Apollo.QueryResult<CustomerReviewsQuery, CustomerReviewsQueryVariables>;
export const ChangeCustomerPasswordDocument = gql`
    mutation ChangeCustomerPassword($currentPassword: String!, $newPassword: String!) {
  changeCustomerPassword(
    currentPassword: $currentPassword
    newPassword: $newPassword
  ) {
    email
    firstname
    lastname
    phone_number
  }
}
    `;
export type ChangeCustomerPasswordMutationFn = Apollo.MutationFunction<ChangeCustomerPasswordMutation, ChangeCustomerPasswordMutationVariables>;

/**
 * __useChangeCustomerPasswordMutation__
 *
 * To run a mutation, you first call `useChangeCustomerPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCustomerPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCustomerPasswordMutation, { data, loading, error }] = useChangeCustomerPasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangeCustomerPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCustomerPasswordMutation, ChangeCustomerPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCustomerPasswordMutation, ChangeCustomerPasswordMutationVariables>(ChangeCustomerPasswordDocument, options);
      }
export type ChangeCustomerPasswordMutationHookResult = ReturnType<typeof useChangeCustomerPasswordMutation>;
export type ChangeCustomerPasswordMutationResult = Apollo.MutationResult<ChangeCustomerPasswordMutation>;
export type ChangeCustomerPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeCustomerPasswordMutation, ChangeCustomerPasswordMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: CustomerInput!) {
  updateCustomer(input: $input) {
    customer {
      firstname
      lastname
    }
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const CustomerRankDocument = gql`
    query CustomerRank {
  customer {
    rank
  }
}
    `;

/**
 * __useCustomerRankQuery__
 *
 * To run a query within a React component, call `useCustomerRankQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerRankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerRankQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerRankQuery(baseOptions?: Apollo.QueryHookOptions<CustomerRankQuery, CustomerRankQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerRankQuery, CustomerRankQueryVariables>(CustomerRankDocument, options);
      }
export function useCustomerRankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerRankQuery, CustomerRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerRankQuery, CustomerRankQueryVariables>(CustomerRankDocument, options);
        }
export function useCustomerRankSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerRankQuery, CustomerRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerRankQuery, CustomerRankQueryVariables>(CustomerRankDocument, options);
        }
export type CustomerRankQueryHookResult = ReturnType<typeof useCustomerRankQuery>;
export type CustomerRankLazyQueryHookResult = ReturnType<typeof useCustomerRankLazyQuery>;
export type CustomerRankSuspenseQueryHookResult = ReturnType<typeof useCustomerRankSuspenseQuery>;
export type CustomerRankQueryResult = Apollo.QueryResult<CustomerRankQuery, CustomerRankQueryVariables>;
export const CreateCustomerAddressDocument = gql`
    mutation CreateCustomerAddress($input: CustomerAddressInput!) {
  createCustomerAddress(input: $input) {
    city
    company
    firstname
    id
    lastname
    region {
      region
      region_code
    }
    district_id
    district
    ward
    ward_id
    telephone
    street
  }
}
    `;
export type CreateCustomerAddressMutationFn = Apollo.MutationFunction<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>;

/**
 * __useCreateCustomerAddressMutation__
 *
 * To run a mutation, you first call `useCreateCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerAddressMutation, { data, loading, error }] = useCreateCustomerAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>(CreateCustomerAddressDocument, options);
      }
export type CreateCustomerAddressMutationHookResult = ReturnType<typeof useCreateCustomerAddressMutation>;
export type CreateCustomerAddressMutationResult = Apollo.MutationResult<CreateCustomerAddressMutation>;
export type CreateCustomerAddressMutationOptions = Apollo.BaseMutationOptions<CreateCustomerAddressMutation, CreateCustomerAddressMutationVariables>;
export const UpdateCustomerAddressDocument = gql`
    mutation UpdateCustomerAddress($updateCustomerAddressId: Int!, $input: CustomerAddressInput) {
  updateCustomerAddress(id: $updateCustomerAddressId, input: $input) {
    city
    company
    firstname
    id
    lastname
    region {
      region
      region_code
    }
    district_id
    district
    ward
    ward_id
    telephone
    street
  }
}
    `;
export type UpdateCustomerAddressMutationFn = Apollo.MutationFunction<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;

/**
 * __useUpdateCustomerAddressMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerAddressMutation, { data, loading, error }] = useUpdateCustomerAddressMutation({
 *   variables: {
 *      updateCustomerAddressId: // value for 'updateCustomerAddressId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>(UpdateCustomerAddressDocument, options);
      }
export type UpdateCustomerAddressMutationHookResult = ReturnType<typeof useUpdateCustomerAddressMutation>;
export type UpdateCustomerAddressMutationResult = Apollo.MutationResult<UpdateCustomerAddressMutation>;
export type UpdateCustomerAddressMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerAddressMutation, UpdateCustomerAddressMutationVariables>;
export const DeleteCustomerAddressDocument = gql`
    mutation DeleteCustomerAddress($deleteCustomerAddressId: Int!) {
  deleteCustomerAddress(id: $deleteCustomerAddressId)
}
    `;
export type DeleteCustomerAddressMutationFn = Apollo.MutationFunction<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>;

/**
 * __useDeleteCustomerAddressMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerAddressMutation, { data, loading, error }] = useDeleteCustomerAddressMutation({
 *   variables: {
 *      deleteCustomerAddressId: // value for 'deleteCustomerAddressId'
 *   },
 * });
 */
export function useDeleteCustomerAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>(DeleteCustomerAddressDocument, options);
      }
export type DeleteCustomerAddressMutationHookResult = ReturnType<typeof useDeleteCustomerAddressMutation>;
export type DeleteCustomerAddressMutationResult = Apollo.MutationResult<DeleteCustomerAddressMutation>;
export type DeleteCustomerAddressMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerAddressMutation, DeleteCustomerAddressMutationVariables>;
export const CustomerWishlistDocument = gql`
    query CustomerWishlist {
  customer {
    wishlist {
      items {
        id
        product {
          sku
        }
      }
      items_count
    }
  }
}
    `;

/**
 * __useCustomerWishlistQuery__
 *
 * To run a query within a React component, call `useCustomerWishlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerWishlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerWishlistQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerWishlistQuery(baseOptions?: Apollo.QueryHookOptions<CustomerWishlistQuery, CustomerWishlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerWishlistQuery, CustomerWishlistQueryVariables>(CustomerWishlistDocument, options);
      }
export function useCustomerWishlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerWishlistQuery, CustomerWishlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerWishlistQuery, CustomerWishlistQueryVariables>(CustomerWishlistDocument, options);
        }
export function useCustomerWishlistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerWishlistQuery, CustomerWishlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerWishlistQuery, CustomerWishlistQueryVariables>(CustomerWishlistDocument, options);
        }
export type CustomerWishlistQueryHookResult = ReturnType<typeof useCustomerWishlistQuery>;
export type CustomerWishlistLazyQueryHookResult = ReturnType<typeof useCustomerWishlistLazyQuery>;
export type CustomerWishlistSuspenseQueryHookResult = ReturnType<typeof useCustomerWishlistSuspenseQuery>;
export type CustomerWishlistQueryResult = Apollo.QueryResult<CustomerWishlistQuery, CustomerWishlistQueryVariables>;
export const CustomerListAddressesDocument = gql`
    query CustomerListAddresses {
  customer {
    phone_number
    addresses {
      default_billing
      default_shipping
      id
    }
  }
}
    `;

/**
 * __useCustomerListAddressesQuery__
 *
 * To run a query within a React component, call `useCustomerListAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerListAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerListAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerListAddressesQuery(baseOptions?: Apollo.QueryHookOptions<CustomerListAddressesQuery, CustomerListAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerListAddressesQuery, CustomerListAddressesQueryVariables>(CustomerListAddressesDocument, options);
      }
export function useCustomerListAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerListAddressesQuery, CustomerListAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerListAddressesQuery, CustomerListAddressesQueryVariables>(CustomerListAddressesDocument, options);
        }
export function useCustomerListAddressesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerListAddressesQuery, CustomerListAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerListAddressesQuery, CustomerListAddressesQueryVariables>(CustomerListAddressesDocument, options);
        }
export type CustomerListAddressesQueryHookResult = ReturnType<typeof useCustomerListAddressesQuery>;
export type CustomerListAddressesLazyQueryHookResult = ReturnType<typeof useCustomerListAddressesLazyQuery>;
export type CustomerListAddressesSuspenseQueryHookResult = ReturnType<typeof useCustomerListAddressesSuspenseQuery>;
export type CustomerListAddressesQueryResult = Apollo.QueryResult<CustomerListAddressesQuery, CustomerListAddressesQueryVariables>;